/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {useContext} from 'react';

import {PageContext} from '@amblique/contentful/app/contexts/contentful';

export function usePageContext() {
  const context = useContext(PageContext);

  if (!context) {
    throw new Error('"usePageContext" cannot be used outside of a page.');
  }

  return context;
}
